<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="标题图片">
				<el-upload
					class="avatar-uploader"
					:action="'https://app.kcguoyi.com/api/service/upload/uploadImage'"
					:auto-upload="false"
					:show-file-list="false"
					:on-change="
						(file, fileList) => {
							handleImport(file, fileList, 'titleImage');
						}
					"
					accept="image/gif,image/jpeg,image/jpg,image/png"
					drag
				>
					<img v-if="list.titleImage" :src="list.titleImage" class="avatar" />
					<i v-else class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-form-item>
			<el-form-item label="背景图片">
				<el-upload
					class="avatar-uploader"
					:action="'https://app.kcguoyi.com/api/service/upload/uploadImage'"
					:auto-upload="false"
					:show-file-list="false"
					:on-change="
						(file, fileList) => {
							handleImport(file, fileList, 'backgroundImage');
						}
					"
					accept="image/gif,image/jpeg,image/jpg,image/png"
					drag
				>
					<img v-if="list.backgroundImage" :src="list.backgroundImage" class="avatar" />
					<i v-else class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-form-item>
			<el-form-item label="外边距">
				<el-input-number v-model="list.marginTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
// 上传图片
import axios from 'axios';
export default {
	name: 'bookShelf',
	props: ['data'],
	data() {
		return {
			list: {},
		};
	},
	mounted() {
		this.list = this.data;
	},
	methods: {
		//图片上传
		handleImport(file, fileList, name) {
			if (fileList.length > 1) {
				fileList.splice(0, 1);
			}
			const params = new FormData();
			params.append('file', file.raw);
			var loading = this.$loading({
				lock: true,
				text: '图片上传中',
			});
			var url = 'https://app.kcguoyi.com/api/service/upload/uploadImage';
			axios
				.post(url, params, {
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				.then((res) => {
					this.list[name] = res.data.body[0].url;
				})
				.finally(() => {
					this.$nextTick(() => {
						this.$forceUpdate();
					});
					loading.close();
				});
		},
	},
};
</script>

<style scoped>
.info-content {
	padding: 20px;
}
.el-input-number {
	width: 220px;
}
div /deep/ .el-upload-dragger {
	width: 220px;
	height: 140px;
}
div /deep/ .el-upload-dragger .el-icon-upload {
	margin-top: 20px;
}

.avatar {
	width: 220px;
	height: 140px;
	display: block;
}
</style>